import React from 'react'

function Quote({color}) {
  return (
    <>
    <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.83775 19.51C2.51907 20.2104 3.03108 21.0059 3.80058 21.0059H6.82279C7.25354 21.0059 7.64127 20.7447 7.8031 20.3455L11.1308 12.1371C11.182 12.0109 11.2083 11.8759 11.2083 11.7397V1.8625C11.2083 1.27828 10.7347 0.804688 10.1505 0.804688H1.64082C1.05661 0.804688 0.583008 1.27829 0.583008 1.8625V11.0106C0.583008 11.5948 1.05661 12.0684 1.64082 12.0684H4.58016C5.34967 12.0684 5.86168 12.8639 5.543 13.5643L2.83775 19.51ZM16.0866 19.51C15.7679 20.2104 16.2799 21.0059 17.0494 21.0059H19.9499C20.3759 21.0059 20.7603 20.7504 20.9253 20.3576L24.3747 12.1424C24.4291 12.0128 24.4572 11.8735 24.4572 11.7329V1.8625C24.4572 1.27828 23.9836 0.804688 23.3994 0.804688H14.8897C14.3055 0.804688 13.8319 1.27829 13.8319 1.8625V11.0106C13.8319 11.5948 14.3055 12.0684 14.8897 12.0684H17.829C18.5985 12.0684 19.1105 12.8639 18.7919 13.5643L16.0866 19.51Z" fill={color ? color : "#223A57"}/>
    </svg>
    </>
  )
}

export default Quote